import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function AdminGuard({ children }) {
    const [ok, setOk] = useState(null);
    // const [ok, setOk] = useState(true);
    useEffect(() => {
        const API = process.env.REACT_APP_API_BASE || 'http://localhost:8080';
        fetch(`${API}/api/auth/me`, { credentials: 'include' })
            .then(r => (r.ok ? r.json() : Promise.reject()))
            .then(() => setOk(true))
            .catch(() => setOk(false));
    }, []);
    if (ok === null) return null;
    // if (!ok) {
    //     if (window.location.pathname === '/admin/login') return children; 
    //     return <Navigate to="/admin/login" replace />;
    // }
    if (!ok) return <Navigate to="/admin/login" replace />;
    return children;
}
